export const nodeIconNames = [
	'node:aggregate',
	'node:ai-agent',
	'node:ai-transform',
	'node:basic-llm-chain',
	'node:calculator',
	'node:call-n8n-sub-workflow-tool',
	'node:character-text-splitter',
	'node:chat-memory-manager',
	'node:chat-trigger',
	'node:code',
	'node:compare-datasets',
	'node:compression',
	'node:contextual-compression-retriever',
	'node:convert-to-file',
	'node:crypto',
	'node:data-table',
	'node:date-and-time',
	'node:default-data-loader',
	'node:edit-fields',
	'node:edit-image',
	'node:email-trigger',
	'node:error-trigger',
	'node:execute-command',
	'node:execute-sub-workflow',
	'node:execution-data',
	'node:extract-from-file',
	'node:filter',
	'node:form-trigger',
	'node:ftp',
	'node:guardrails',
	'node:html',
	'node:http-request',
	'node:if',
	'node:information-extractor',
	'node:item-list-output-parser',
	'node:limit',
	'node:local-file-trigger',
	'node:loop-over-items',
	'node:manual-trigger',
	'node:markdown',
	'node:merge',
	'node:model-selector',
	'node:multiquery-retriever',
	'node:n8n',
	'node:n8n-trigger',
	'node:no-operation',
	'node:question-and-answer-chain',
	'node:read-write-files-from-disk',
	'node:recursive-character-text-splitter',
	'node:remove-duplicates',
	'node:rename-keys',
	'node:respond-to-webhook',
	'node:rss-feed-trigger',
	'node:rss-read',
	'node:schedule-trigger',
	'node:send-mail',
	'node:sentiment-analysis',
	'node:simple-memory',
	'node:simple-vector-store',
	'node:sort',
	'node:split-out',
	'node:sse-trigger',
	'node:ssh',
	'node:stop-and-error',
	'node:structured-output-parser',
	'node:sub-workflow-trigger',
	'node:summarization-chain',
	'node:summarize',
	'node:switch',
	'node:text-classifier',
	'node:think-tool',
	'node:token-splitter',
	'node:totp',
	'node:track-time-saved',
	'node:vector-store-question-answer-tool',
	'node:vector-store-retriever',
	'node:wait',
	'node:webhook',
	'node:workflow-retriever',
	'node:xml',
] as const;

export type NodeIconName = (typeof nodeIconNames)[number];
